import * as React from 'react';
const SvgTiktok = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#fff"
      d="M19 8c-2.21 0-4-1.79-4-4h-2.5v11a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 2.5-2.5c.36 0 .69.08 1 .21V10.1A5.002 5.002 0 0 0 5 15c0 2.76 2.24 5 5 5s5-2.24 5-5V9.12a6.48 6.48 0 0 0 4 1.38z"
    />
  </svg>
);
export default SvgTiktok;
